/**
 * MyAttendance — ประวัติการเข้างานของพนักงาน (TASK 24b).
 * Range picker → stat cards → day-by-day timeline (shared AttendanceTimeline).
 *
 * บริษัทที่ปิดรอบจ่ายไม่ตรงสิ้นเดือน (TN Riches 26 → 25) เปิดหน้ามาที่ "รอบจ่ายนี้" ทันที
 * ให้พนักงานตรวจเวลาของตัวเองตรงกับรอบที่ใช้คิดเงิน (24 ก.ย. 2569)
 */
import { useState } from 'react';
import { PageLayout } from '../components/layout/PageLayout';
import { useMyAttendance, useMyPayCycle } from '../hooks';
import {
  AttendanceTimeline,
  AttendanceRangePresets,
  rangeForPreset,
  thisMonthRange,
  todayBkk,
  type RangePreset,
} from '../components/domain/AttendanceTimeline';
import { isCalendarMonthCycle } from '@payroll/shared';

export function MyAttendance() {
  const { data: payCycle, isLoading: cycleLoading } = useMyPayCycle();
  const cutoffDay = payCycle?.cutoff_day ?? undefined;
  const useCycle = !!cutoffDay && !isCalendarMonthCycle(cutoffDay, todayBkk().slice(0, 7));

  const [range, setRange] = useState(thisMonthRange);
  const [preset, setPreset] = useState<RangePreset>('this-month');
  // ตั้งค่าเริ่มต้นเป็นรอบจ่ายครั้งเดียวเมื่อรู้วันปิดรอบ (ผู้ใช้กดปุ่มอื่นหลังจากนั้นไม่ถูกดึงกลับ)
  const [synced, setSynced] = useState(false);
  if (!synced && payCycle) {
    setSynced(true);
    if (useCycle) {
      setPreset('cycle');
      setRange(rangeForPreset('cycle', cutoffDay));
    }
  }
  // รอรู้รอบจ่ายก่อนค่อยโหลด — ไม่งั้นยิงเดือนปฏิทินก่อนแล้วกระพริบเปลี่ยนช่วง
  const ready = synced || (!cycleLoading && !payCycle);
  const { data, isLoading } = useMyAttendance(range, ready);

  function applyPreset(p: RangePreset) {
    setPreset(p);
    setRange(rangeForPreset(p, cutoffDay));
  }

  return (
    <PageLayout title="ประวัติการเข้างาน">
      <AttendanceRangePresets
        preset={preset}
        onChange={applyPreset}
        cutoffDay={useCycle ? cutoffDay : undefined}
        range={useCycle ? range : undefined}
      />
      <AttendanceTimeline data={ready ? data : undefined} isLoading={!ready || isLoading} />
    </PageLayout>
  );
}
